module.exports = __webpack_public_path__ + "static/img_0960-f5379380cfa49aa53724e9d131afff0a.webp";